exports = module.exports = require("../../node_modules/.pnpm/registry.nlark.com+css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-parent[data-v-5341f39a]{margin-top:20px;padding:20px;border:4px solid #eb2f96}.action[data-v-5341f39a]{margin-right:5px}", ""]);

// exports
